import { memo } from 'react';
import { CartBody } from '../../__partials/CartBody';
import { CartFooter } from '../../__partials/CartFooter';
import { CartHeader } from '../../__partials/CartHeader';

export const CartExplore = memo(() => {
  return (
    <>
      <CartHeader />
      <CartBody />
      <CartFooter />
    </>
  );
});
